import React from 'react';
import ReactDOM from 'react-dom';
import VideoModalList from '../../videoPlayer/components/VideoPlaylist';
import FsPlaylistService from '../../shared/services/FsPlaylistService';
import { getPostId } from '../../shared/utils';

class VideoPlaylistHandler {
    constructor() {
        this.postId = getPostId();
    	this.firstVideo = document.querySelector('#story-1 .platformPlayer[data-player-config]:not(.tpPlayer)');
        this.playlistContainer = document.getElementById('video-playlist');
    	this.clickToPlay = ( this.playlistContainer !== null && this.playlistContainer.hasAttribute('data-click-to-play') ) ? this.playlistContainer.getAttribute('data-click-to-play') : true;
        if( this.firstVideo !== null && this.playlistContainer !== null ) { this.launchVideoPlayList(); }
    }

    updateCurrentPost(post) {

    	if (this.clickToPlay) {
	        let player = window.fdmPlayer[0];

	        if(player) {
	            player.setReleaseCall(post.releaseUrl);
	        }    		
    	} else {
    		window.open(post.videoUrl,"_self");
    	}
    }

    launchVideoPlayList(item){

    	let playlistContainer = this.playlistContainer;
        let firstVideoConfig = this.firstVideo.getAttribute('data-player-config');
        let title = "TOP " + playlistContainer.getAttribute('data-category') + " VIDEOS";
        let endcardfeed = JSON.parse(firstVideoConfig)['endcard_feed'];
        let updateCurrentPost = this.updateCurrentPost;
        let limit = 7;
        let updateDetails = this.updateDetails;

        new FsPlaylistService().getMpxPlaylist( endcardfeed, limit, this.postId).then( topVideos => {
	        ReactDOM.render(<VideoModalList title={title} videos={topVideos} enableShowMore={false} onClick={updateCurrentPost} hideTitle={true}/>, playlistContainer);
        });
    }
}

export default new VideoPlaylistHandler();